import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { AlertErrorIcon, TrashIcon } from '../../Icons';
import ConfirmIcon from '../../Icons/Confirm';
import { customModalStyles } from '../../../helpers/constants';
import * as styles from './../style';
import withProducts from '../../../containers/Products';
import { getParentSelector } from '../../../helpers/modal';
import { DANGER_COLOR } from '../../../styles/variables';
import Loader from '4all-ui/components/Loader';

const ProductActionModal = props => {
  const {
    isDeleted,
    isLoadingSubmitProduct,
    productRequestError,
    show,
    onCloseActionModal,
    changeProductStatusModal,
    onSubmitActionModal,
  } = props;
  const { product } = props.modalProduct.data;

  return (
    <Modal
      id="generic-product-action-modal"
      ariaHideApp={false}
      isOpen={show}
      style={{
        ...customModalStyles,
        content: {
          ...customModalStyles.content,
          height: 'auto',
          width: 'auto',
        },
      }}
      onRequestClose={onCloseActionModal}
      parentSelector={getParentSelector}
    >
      <styles.Container>
        <styles.Content>
          {getContent(
            isDeleted,
            isLoadingSubmitProduct,
            productRequestError,
            product,
            changeProductStatusModal
          )}
        </styles.Content>

        <styles.Footer center={isDeleted}>
          {isDeleted || productRequestError ? (
            <styles.OKButton
              id="action-modal-ok-button"
              onClick={() => onCloseActionModal(productRequestError)}
              disabled={isLoadingSubmitProduct}
            >
              OK
            </styles.OKButton>
          ) : (
            <React.Fragment>
              <styles.CancelButton
                id="action-modal-cancel-button"
                onClick={() => onCloseActionModal(productRequestError)}
                disabled={isLoadingSubmitProduct}
              >
                Cancelar
              </styles.CancelButton>
              <styles.DeleteButton
                id="action-modal-delete-button"
                onClick={() => {
                  onSubmitActionModal();
                }}
                disabled={isLoadingSubmitProduct}
              >
                {changeProductStatusModal ? 'Inativar' : 'Excluir'}
              </styles.DeleteButton>
            </React.Fragment>
          )}
        </styles.Footer>
      </styles.Container>
    </Modal>
  );
};

const getContent = (
  isDeleted,
  isLoadingSubmitProduct,
  productRequestError,
  product,
  changeProductStatusModal
) => {
  if (isLoadingSubmitProduct) {
    return (
      <styles.ContentLoader>
        <Loader size="100px" width="8px" />
      </styles.ContentLoader>
    );
  } else if (productRequestError && productRequestError.message) {
    return (
      <React.Fragment>
        <AlertErrorIcon />
        <styles.Title>{productRequestError.message}</styles.Title>
      </React.Fragment>
    );
  } else {
    if (isDeleted) {
      return (
        <React.Fragment>
          <ConfirmIcon size="120px" />
          <styles.Title id="generic-product-action-modal-msg">
            {product && product.idCategory
              ? 'Sua categoria foi excluída '
              : 'Seu produto foi excluído '}
            <br />
            com sucesso!
          </styles.Title>
        </React.Fragment>
      );
    } else {
      if (changeProductStatusModal) {
        return (
          <React.Fragment>
            <AlertErrorIcon size="90px" color={DANGER_COLOR} />
            <styles.Title id="generic-product-action-modal-msg">
              Produto vinculado à um cardápio
            </styles.Title>
            <styles.Text>Se for inativado, será excluído do cardápio.</styles.Text>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment>
          <TrashIcon size="90px" color={DANGER_COLOR} />
          <styles.Title id="generic-product-action-modal-msg">Excluir Item</styles.Title>
          <styles.Text>Deseja excluir os produtos selecionados?</styles.Text>
        </React.Fragment>
      );
    }
  }
};

ProductActionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  isDeleted: PropTypes.bool.isRequired,
  onSubmitActionModal: PropTypes.func.isRequired,
  onCloseActionModal: PropTypes.func.isRequired,
};

export default withProducts(ProductActionModal);



// WEBPACK FOOTER //
// ./src/components/GenericModal/ProductActionModal/index.js